import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
.vjs-matrix .vjs-control-bar {
  background: black;
}

.vjs-matrix .vjs-tech {
  position:relative;
}
`;
